const REACT_APP_SBMA_ADMIN_API_ENDPOINT = process.env.REACT_APP_EID_ADMIN_API_ENDPOINT;
const RBAC_BASE_URL = REACT_APP_SBMA_ADMIN_API_ENDPOINT + "/api/v1/rbac";

export default {

    GET_PROFILE_PERMISSION:                     RBAC_BASE_URL + "/profile/permission",
    GET_ROLE_BY_PROFILE_TYPE:                   RBAC_BASE_URL + "/profile/role",
}